module.exports = {
          srcSet: __webpack_public_path__ + "public/9c462ad699f1492581901b09ef4b3992-49.png"+" 49w",
          images:[ {path: __webpack_public_path__ + "public/9c462ad699f1492581901b09ef4b3992-49.png",width: 49,height: 27}],
          src: __webpack_public_path__ + "public/9c462ad699f1492581901b09ef4b3992-49.png",
          toString:function(){return __webpack_public_path__ + "public/9c462ad699f1492581901b09ef4b3992-49.png"},
          
          width: 49,
          height: 27
        }